/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Errordescription1Inputs */

const id_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline yang dipilih mungkin tidak tersedia atau tidak kompatibel. Pilih build terverifikasi lain dan coba lagi.`)
};

const ms_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garis dasar yang dipilih mungkin tidak tersedia atau tidak serasi. Pilih binaan disahkan lain dan cuba lagi.`)
};

const da_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den valgte basis kan være utilgængelig eller inkompatibel. Vælg et andet bekræftet build, og prøv igen.`)
};

const de_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die ausgewählte Basis ist möglicherweise nicht verfügbar oder inkompatibel. Wähle einen anderen verifizierten Build und versuche es erneut.`)
};

const en_us2_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The selected baseline may be unavailable or incompatible. Choose another verified build and try again.`)
};

const es_es2_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La compilación de referencia puede no estar disponible o ser incompatible. Elige otra compilación verificada e inténtalo de nuevo.`)
};

const es_mx2_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La compilación de referencia puede no estar disponible o ser incompatible. Elige otra compilación verificada e inténtalo de nuevo.`)
};

const fil_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maaaring hindi available o hindi tugma ang napiling baseline. Pumili ng ibang na-verify na build at subukan muli.`)
};

const fr_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La base sélectionnée est peut-être indisponible ou incompatible. Choisissez un autre build vérifié et réessayez.`)
};

const it_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La base selezionata potrebbe non essere disponibile o compatibile. Scegli un’altra build verificata e riprova.`)
};

const hu_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A kiválasztott alap nem érhető el, vagy nem kompatibilis. Válassz másik ellenőrzött buildet, majd próbáld újra.`)
};

const nl_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De geselecteerde basis is mogelijk niet beschikbaar of incompatibel. Kies een andere geverifieerde build en probeer het opnieuw.`)
};

const no_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den valgte basen kan være utilgjengelig eller inkompatibel. Velg en annen bekreftet build og prøv igjen.`)
};

const pl_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybrana baza może być niedostępna lub niezgodna. Wybierz inny zweryfikowany build i spróbuj ponownie.`)
};

const pt_br2_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A base selecionada pode estar indisponível ou ser incompatível. Escolha outro build verificado e tente novamente.`)
};

const pt_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A base selecionada pode estar indisponível ou ser incompatível. Escolha outra compilação verificada e tente novamente.`)
};

const ro_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baza selectată poate fi indisponibilă sau incompatibilă. Alege alt build verificat și încearcă din nou.`)
};

const fi_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valittu perusta ei ehkä ole saatavilla tai yhteensopiva. Valitse toinen vahvistettu build ja yritä uudelleen.`)
};

const sv_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den valda basen kanske inte är tillgänglig eller kompatibel. Välj en annan verifierad build och försök igen.`)
};

const vi_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline đã chọn có thể không khả dụng hoặc không tương thích. Hãy chọn một build đã xác minh khác và thử lại.`)
};

const tr_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seçilen temel kullanılamıyor veya uyumsuz olabilir. Başka bir doğrulanmış derleme seçip tekrar deneyin.`)
};

const cs_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybraná základní kompilace může být nedostupná nebo nekompatibilní. Vyberte jiný ověřený build a zkuste to znovu.`)
};

const bg_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Избраната базова компилация може да е недостъпна или несъвместима. Изберете друга проверена компилация и опитайте отново.`)
};

const ru_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбранная в качестве базовой сборка может быть недоступна или несовместима. Выберите другую проверенную сборку и повторите попытку.`)
};

const uk_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вибрана база може бути недоступною або несумісною. Виберіть інший перевірений білд і спробуйте ще раз.`)
};

const ar_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قد تكون القاعدة المحددة غير متاحة أو غير متوافقة. اختر بناءً آخر تم التحقق منه وحاول مجددًا.`)
};

const hi_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित बेसलाइन अनुपलब्ध या असंगत हो सकती है। कोई दूसरा सत्यापित बिल्ड चुनकर फिर कोशिश करें।`)
};

const th_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฐานที่เลือกอาจไม่พร้อมใช้งานหรือเข้ากันไม่ได้ เลือกบิลด์ที่ยืนยันแล้วรายการอื่นแล้วลองอีกครั้ง`)
};

const ja_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したベースラインは利用できないか互換性がない可能性があります。別の検証済みビルドを選んで再試行してください。`)
};

const zh_cn2_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所选基线可能不可用或不兼容。请选择其他已验证构建，然后重试。`)
};

const zh_hant1_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選取的基準可能無法使用或不相容。請選擇其他已驗證組建並重試。`)
};

const ko_builds_comparison_errordescription1 = /** @type {(inputs: Builds_Comparison_Errordescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선택한 기준 빌드를 사용할 수 없거나 호환되지 않을 수 있습니다. 다른 검증된 빌드를 선택하고 다시 시도하세요.`)
};

/**
* | output |
* | --- |
* | "The selected baseline may be unavailable or incompatible. Choose another verified build and try again." |
*
* @param {Builds_Comparison_Errordescription1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_errordescription1 = /** @type {((inputs?: Builds_Comparison_Errordescription1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Errordescription1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_errordescription1(inputs)
	if (locale === "ms") return ms_builds_comparison_errordescription1(inputs)
	if (locale === "da") return da_builds_comparison_errordescription1(inputs)
	if (locale === "de") return de_builds_comparison_errordescription1(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_errordescription1(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_errordescription1(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_errordescription1(inputs)
	if (locale === "fil") return fil_builds_comparison_errordescription1(inputs)
	if (locale === "fr") return fr_builds_comparison_errordescription1(inputs)
	if (locale === "it") return it_builds_comparison_errordescription1(inputs)
	if (locale === "hu") return hu_builds_comparison_errordescription1(inputs)
	if (locale === "nl") return nl_builds_comparison_errordescription1(inputs)
	if (locale === "no") return no_builds_comparison_errordescription1(inputs)
	if (locale === "pl") return pl_builds_comparison_errordescription1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_errordescription1(inputs)
	if (locale === "pt") return pt_builds_comparison_errordescription1(inputs)
	if (locale === "ro") return ro_builds_comparison_errordescription1(inputs)
	if (locale === "fi") return fi_builds_comparison_errordescription1(inputs)
	if (locale === "sv") return sv_builds_comparison_errordescription1(inputs)
	if (locale === "vi") return vi_builds_comparison_errordescription1(inputs)
	if (locale === "tr") return tr_builds_comparison_errordescription1(inputs)
	if (locale === "cs") return cs_builds_comparison_errordescription1(inputs)
	if (locale === "bg") return bg_builds_comparison_errordescription1(inputs)
	if (locale === "ru") return ru_builds_comparison_errordescription1(inputs)
	if (locale === "uk") return uk_builds_comparison_errordescription1(inputs)
	if (locale === "ar") return ar_builds_comparison_errordescription1(inputs)
	if (locale === "hi") return hi_builds_comparison_errordescription1(inputs)
	if (locale === "th") return th_builds_comparison_errordescription1(inputs)
	if (locale === "ja") return ja_builds_comparison_errordescription1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_errordescription1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_errordescription1(inputs)
	return ko_builds_comparison_errordescription1(inputs)
});
export { builds_comparison_errordescription1 as "builds.comparison.errorDescription" }